import { TDocumentTypes } from "../screens/Chat/types";

export const getContentType = (contentType?: string | null): TDocumentTypes => {
  return (contentType?.split("/")?.[0] || "") as TDocumentTypes;
};
